import React, { useState, useEffect } from "react";
import { getVCMS, publishVCMS } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { createVCMS, editVCMS } from "../../api/api";
import { jwStore, NecStore } from "../../store/necStore";
import ToolTip from "../tooltip/tooltip";
// import { UserLang } from "../../store/userStore";

const YouTube = (props) => {
  const initState = {
    cloudName: props.type,
    cloudKey: "",
    cloudSecret: "",
    cloudKeyV2: "",
    cloudSecretV2: "",
    mainAccountId: "",
    secondAccountId: "",
    firstPlayer: "",
    secondPlayer: "",
    premiumPlayer: "",
    licenseKey: "",
    iosLicenseKey: "",
    premLicenseKey: "",
    iosPremLicenseKey: "",
    secLicenseKey: "",
    iosSecLicenseKey: "",
    drmKey: "",
    drmMobileKey: "",
    drmTVKey: "",
    searchPlaylist: "",
    recommendedPlaylist: "",
    watchPlaylist: "",
  };

  const [editing, setEditing] = useState(initState);
  const [vcmsCount, setVcmsCount] = useState("");
  const [vcmsStatus, setVcmsStatus] = useState(0);
  const role = NecStore.useState((s) => s.setting);
  const [lan] = useState("ltr");
  const handleChange = (evt) => {
    const value = evt.target.value;
    setEditing({
      ...editing,
      [evt.target.name]: value,
    });
  };

  useEffect(() => {
    const videoDetail = async () => {
      const result = await getVCMS().then(
        (result) => {
          jwStore.update((s) => {
            s.jw = result.data;
          });
          setEditing(result.data);
        },
        (error) => {
          const obj = {
            status: error.response.data.error.status,
            message: error.response.data.error.message,
          };
          setVcmsCount(obj.message);
          setVcmsStatus(obj.status);
        }
      );
      /* eslint-disable no-unused-vars */
    };
    videoDetail();
  }, []);

  const videoSave = async (event) => {
    event.preventDefault();

    if (
      !!editing.cloudKey &&
      !!editing.cloudSecret &&
      !!editing.mainAccountId &&
      !!editing.firstPlayer &&
      !!editing.licenseKey
    ) {
      if (vcmsStatus === 404 || vcmsCount === "No Video Cloud Account Exists") {
        const result = await createVCMS(editing).then(
          (result) => {
            toastr.success("Successfully Saved", "Success");
          },
          (error) => {
            const obj = {
              status: error.response.data.error.status,
              message: error.response.data.error.message,
            };
            return obj;
          }
        );
        /* eslint-disable no-unused-vars */
      } else {
        /* eslint-disable no-unused-vars */
        const result = await editVCMS(editing).then(
          (result) => {
            toastr.success("Successfully Saved", "Success");
          },
          (error) => {
            const obj = {
              status: error.response.data.error.status,
              message: error.response.data.error.message,
            };
            return obj;
          }
        );
        /* eslint-disable no-unused-vars */
      }
    } else {
      toastr.error("Please fill all fields with * notation", "Required");
    }
  };

  const publish = async (event) => {
    // setDisable(true);
    // setLoading(true);
    event.preventDefault();
    if (role.production === true) {
      const result = await publishVCMS().then(
        (result) => {
          toastr.success("Successfully Published", "Success");
        },
        (error) => {
          toastr.error(error.response.data.error.message, "Error");
          // setLoading(false);
        }
      );
    } else {
      toastr.error("Preview Environment is off", "Error");
    }
    /* eslint-disable no-unused-vars */
  };

  return (
    <div>
      <form onSubmit={videoSave}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {lan === "rtl" && (
                  <ToolTip
                    info={"Api key from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}
                &nbsp; Api Key * &nbsp;
                {!(lan === "rtl") && (
                  <ToolTip
                    info={"Api key from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}
              </label>
              <input
                type="text"
                name="cloudKey"
                className="form-control inside-form"
                dir={lan === "rtl" ? "rtl" : "ltr"}
                placeholder="API Key ..."
                defaultValue={editing.cloudKey}
                onChange={handleChange}
                required
                autoComplete="off"
              />
            </div>
          </div>
          <div className="col-sm-6">
            {/* text input */}
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {lan === "rtl" && (
                  <ToolTip
                    info={"Channel Id from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}
                &nbsp; Channel Id * &nbsp;
                {!(lan === "rtl") && (
                  <ToolTip
                    info={"Channel Id from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}
              </label>
              <input
                type="text"
                name="cloudSecret"
                className="form-control inside-form"
                dir={lan === "rtl" ? "rtl" : "ltr"}
                placeholder="API Secret"
                defaultValue={editing.cloudSecret}
                onChange={handleChange}
                required
                autoComplete="off"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group">
              <label className={lan === "rtl" ? "float-right" : "float-left"}>
                {lan === "rtl" && (
                  <ToolTip
                    info={"Recommendation playlist from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}
                &nbsp;Recommendation Playlist*&nbsp;
                {!(lan === "rtl") && (
                  <ToolTip
                    info={"Recommendation playlist from YouTube"}
                    place={lan === "rtl" ? "left" : "right"}
                  />
                )}{" "}
              </label>
              <input
                type="text"
                name="cloudKeyV2"
                className="form-control inside-form"
                dir={lan === "rtl" ? "rtl" : "ltr"}
                placeholder="API Key V2 ..."
                defaultValue={editing.cloudKeyV2}
                onChange={handleChange}
                autoComplete="off"
              />
            </div>
          </div>
        </div>
        {/* <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label className={lan==="rtl"?"float-right":"float-left"}>{(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp;OAuth token(IOS)*&nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}</label>
        <input type="text" name="cloudSecretV2" className="form-control inside-form" dir={lan==="rtl"?"rtl":"ltr"} placeholder="API Secret V2" defaultValue ={editing.cloudSecretV2} onChange={handleChange}   autoComplete="off"/>
      </div>
    </div>
  
  </div> */}
        {/* <div className="row">
    <div className="col-sm-6">
      <div className="form-group">
        <label className={lan==="rtl"?"float-right":"float-left"}>{(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}&nbsp;OAuth token(Chrome App)*&nbsp;{!(lan==="rtl")&&<ToolTip 
            info={"Publish date of the Article"}
            place={lan==="rtl"?"left":"right"}/>}</label>
        <input type="text" name="mainAccountId" className="form-control inside-form" dir={lan==="rtl"?"rtl":"ltr"} placeholder="Main Property"  defaultValue ={editing.mainAccountId} onChange={handleChange}  required autoComplete="off" />
      </div>
    </div> */}

        {/* <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>Trailer Property id </label>
        <input type="text" name="secondAccountId" className="form-control inside-form" placeholder="Trailer Property"  defaultValue ={editing.secondAccountId} onChange={handleChange}    autoComplete="off"/>
      </div>
    </div> */}

        {/* </div> */}
        {/* <div className="row">
    <div className="col-sm-6">
      <div className="form-group">
        <label>Main Player id *</label>
        <input type="text" name="firstPlayer" className="form-control inside-form" placeholder="Main Player"  defaultValue ={editing.firstPlayer} onChange={handleChange}   required autoComplete="off" />
      </div>
    </div>

    <div className="col-sm-6">
      <div className="form-group">
        <label>Premium Player id *</label>
        <input type="text" name="premiumPlayer" className="form-control inside-form" placeholder="Premium Player"  defaultValue ={editing.premiumPlayer} onChange={handleChange}   autoComplete="off" />
      </div>
    </div>
    <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>Secondary Player id</label>
        <input type="text" name="secondPlayer" className="form-control inside-form" placeholder="Secondary Player"  defaultValue ={editing.secondPlayer} onChange={handleChange}    autoComplete="off"/>
      </div>
    </div>
    
    <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>Watch History Playlist</label>
        <input type="text" name="watchPlaylist" className="form-control inside-form" placeholder="Watch History Playlist Id.."   defaultValue ={editing.watchPlaylist} onChange={handleChange}    autoComplete="off"/>
      </div>
    </div>
  
  
  </div>
  <div className="row">
    <div className="col-sm-6">
      <div className="form-group">
        <label>Main Player Android License Key*</label>
        <input type="text" name="licenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.licenseKey} onChange={handleChange}   required autoComplete="off" />
      </div>
    </div>
    <div className="col-sm-6">
      <div className="form-group">
        <label>Main Player iOS License Key *</label>
        <input type="text" name="iosLicenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.iosLicenseKey} onChange={handleChange}   required autoComplete="off" />
      </div>
    </div>
    <div className="col-sm-6">
      <div className="form-group">
        <label>Secondary Player Android License Key*</label>
        <input type="text" name="secLicenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.secLicenseKey} onChange={handleChange}  autoComplete="off" />
      </div>
    </div>

    <div className="col-sm-6">
      <div className="form-group">
        <label>Secondary Player iOS License Key*</label>
        <input type="text" name="iosSecLicenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.iosSecLicenseKey} onChange={handleChange} autoComplete="off" />
      </div>
    </div>
    <div className="col-sm-6">
      <div className="form-group">
        <label>Premium Player Android License Key*</label>
        <input type="text" name="premLicenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.premLicenseKey} onChange={handleChange}  autoComplete="off" />
      </div>
    </div>

    <div className="col-sm-6">
      <div className="form-group">
        <label>Premium Player iOS License Key*</label>
        <input type="text" name="iosPremLicenseKey" className="form-control inside-form" placeholder="License Key"  defaultValue ={editing.iosPremLicenseKey} onChange={handleChange}  autoComplete="off" />
      </div>
    </div>
  
  
  </div>
  <div className="row">
  <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>DRM High Policy Key</label>
        <input type="text" name="drmTVKey" className="form-control inside-form" placeholder="DRM High Policy Key"  defaultValue ={editing.drmTVKey} onChange={handleChange}   autoComplete="off"/>
      </div>
    </div>
    <div className="col-sm-6">
      <div className="form-group">
        <label>DRM Medium Policy Key</label>
        <input type="text" name="drmKey" className="form-control inside-form" placeholder="DRM Medium Policy Key"  defaultValue ={editing.drmKey} onChange={handleChange}    autoComplete="off" />
      </div>
    </div>
    <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>DRM Low Policy Key</label>
        <input type="text" name="drmMobileKey" className="form-control inside-form" placeholder="DRM Low Policy Key"   defaultValue ={editing.drmMobileKey} onChange={handleChange}    autoComplete="off"/>
      </div>
    </div>

    <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>Search Playlist</label>
        <input type="text" name="searchPlaylist" className="form-control inside-form" placeholder="Search Playlist Id.."   defaultValue ={editing.searchPlaylist} onChange={handleChange}    autoComplete="off"/>
      </div>
    </div>

    <div className="col-sm-6"> */}
        {/* text input */}
        {/* <div className="form-group">
        <label>Recommendation Playlist</label>
        <input type="text" name="recommendedPlaylist" className="form-control inside-form" placeholder="Recommendation Playlist Id.."   defaultValue ={editing.recommendedPlaylist} onChange={handleChange}    autoComplete="off"/>
      </div> */}
        {/* </div> */}

        {/* </div> */}
        <div className="row">
          <div className="col-12">
            <div
              className={
                lan === "rtl"
                  ? "btn-group btn-group-md float-left"
                  : "btn-group btn-group-md float-right"
              }
              role="group"
            >
              <button
                type="submit"
                className="btn btn-primary"
                style={{ width: "100px", marginRight: "6px" }}
              >
                Save
              </button>
              <button
                type="button"
                onClick={publish}
                className="btn btn-success"
                style={{ width: "100px", marginRight: "6px" }}
                disabled={!role.production === true ? true : false}
                hidden={!role.production === true ? true : false}
              >
                Publish
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default YouTube;
